module.exports = __webpack_public_path__ + "src/img/timer/54415883c3149c401765c841b2e77382.png";